import React, { useEffect, useState } from "react";
import { useTemplateContext } from "../../../context/TemplateContext";

import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";

import axiosInstance, { handleApiError } from "../../../services/axiosService";
import RecordviewTemplateEditor from "./RecordviewTemplateEditor";

const RecordviewTemplateViewer = ({ file }) => {
  const { setTemplateData, templateData } = useTemplateContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTemplate = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/recordview-template/${file.id}`);
      setTemplateData(data);
    } catch (err) {
      setError("Failed to load Record View template.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!templateData) return null;

  return <RecordviewTemplateEditor file={file} templateData={templateData} setTemplateData={setTemplateData} />;
};

export default RecordviewTemplateViewer;
